<div class="p-5">
	<div class="d-flex text-center align-center flex-column">
		<div class="align-self-center pb-3">
			<mat-spinner></mat-spinner>
		</div>
		<div *ngIf="!message">
			<div class="text-black">Preparando o Download do arquivo....</div>
			<div class="text-black">Este processo pode demorar mais que 2 minutos.</div>
		</div>
		<div *ngIf="message" class="text-black">
			{{ message }}
		</div>
	</div>
</div>
